import axios from 'axios';
import * as url from "../config/BackendConfig";


class DashboardService {

    getPredictionsReportOverview = (token, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.PREDICTIONS_REPORT_OVERVIEW;
        return axios.get(reuquestUrl, config);
    };


    getPredictionsReportByMarket = (token, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.PREDICTIONS_BY_MARKET;
        return axios.get(reuquestUrl, config);
    };


    getPredictionsReportByMarketOptions = (token, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.PREDICTIONS_BY_MARKET_OPTIONS;
        return axios.get(reuquestUrl, config);
    };


    getPredictionsReportByTimeSeries = (token, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.PREDICTIONS_REPORT_TIMESERIES;
        return axios.get(reuquestUrl, config);
    };


    getBalanceReportByTimeSeries = (token, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.BALANCE_REPORT_TIMESERIES;
        return axios.get(reuquestUrl, config);
    };


    getTriplePredictions = (token, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.TRIPLE_PREDICTIONS;
        return axios.get(reuquestUrl, config);
    };

}

const DashboardServiceInstance = new DashboardService();
export default DashboardServiceInstance;